/**
 * 사업자등록번호 유효성 검사 결과
 */
export interface BusinessRegNumberValidation {
  isValid: boolean;
  error?: string;
}

/**
 * 사업자등록번호 유효성 검사
 * - 10자리 길이 확인
 * - 법인사업자(영리) 여부 확인 (4~5번째 자리가 81, 84, 85, 86, 87, 88)
 *
 * @param value - 사업자등록번호 (10자리 숫자 문자열)
 * @returns 유효성 검사 결과
 *
 * @example
 * validateBusinessRegNumber('1234567890') // { isValid: false, error: '법인사업자(영리)만 등록할 수 있어요' }
 * validateBusinessRegNumber('1238112345') // { isValid: true }
 */
export const validateBusinessRegNumber = (value: string): BusinessRegNumberValidation => {
  if (value.length < 10) {
    return { isValid: false, error: '10자리를 모두 입력해주세요' };
  }

  // 법인사업자 체크 (4~5번째 자리가 81, 84, 85, 86, 87, 88인지 확인)
  const nn = value.slice(3, 5);
  if (!['81', '84', '85', '86', '87', '88'].includes(nn)) {
    return { isValid: false, error: '법인사업자(영리)만 등록할 수 있어요' };
  }

  return { isValid: true };
};
